import { applyDiff } from './actions/applyDiff'
import { RootState } from '../../reducers'
import { getSocketId } from '../socketServer'
import { cliLog } from '../../lib/cliLog'
import { FeedbotDispatch } from '../types'
import {
  isOriginalVersionFlowLoadingSelector,
  latestVersionFlowSelector
} from '../../features/serverBots/selectors'

export function tryToApplyDiff(
  state: RootState,
  dispatch: FeedbotDispatch,
  forceDiff?: boolean
): void {
  if (!state.socketServer.roomState?.botState) {
    cliLog('Skipping tryToApplyDiff - missing bot state')
    return
  }

  const originalVersionFlow = latestVersionFlowSelector(state)
  const isOriginalVersionLoading = isOriginalVersionFlowLoadingSelector(state)

  if (!originalVersionFlow) {
    cliLog(`NO DIFF APPLY - no original version`)
    return
  }

  if (isOriginalVersionLoading) {
    cliLog(`NO DIFF APPLY - fetching original version`)
    return
  }

  if (state.socketServer.roomState?.botState?.authorSocketId === getSocketId() && !forceDiff) {
    cliLog(`NO DIFF APPLY - own action`)
    return
  }

  dispatch(applyDiff(originalVersionFlow, state.socketServer.roomState?.botState.diff))
}
